import { render, staticRenderFns } from "./EmployeesAssignmentPage.vue?vue&type=template&id=358f698a&scoped=true&"
import script from "./EmployeesAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./EmployeesAssignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f698a",
  null
  
)

export default component.exports